/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

window.onload = function() {
    if (!sessionStorage.getItem('popupShown')) {
        var iframeContent = '<iframe id="brevo-iframe" width="540" height="540" src="https://2a35fcea.sibforms.com/serve/MUIFAHcuak4ZmjjxgLEZSdyFrnfyAf4CxV-nOXgcwzimH56LKKRZcVn_zcvI9BPuZpl4XgqubKMN28nAkPwCE3RkqiXZbcD9Mud503Vb1ZZmxA_owmfdOWJPV5TgBvwV94g-NzW_oeGnHCJpQqY2AijHkUfvZ0hS3azR41nwzIxEKYuKQJ1NwIXOTepGynhOL9n-AdeMhgWxWh1B" frameborder="0" scrolling="auto" allowfullscreen="" style="display: block;margin-left: auto;margin-right: auto;max-width: 100%;"></iframe>';

        function showPopup() {
            console.log("Showing popup...");
            var popupDiv = document.createElement('div');
            popupDiv.className = 'custom-popup';

            var closeButton = document.createElement('button');
            closeButton.innerHTML = '✕';
            closeButton.setAttribute('aria-label', 'Popup schließen');
            closeButton.className = 'close-popup';
            closeButton.addEventListener('click', function() {
                document.body.removeChild(popupDiv);
                removeOverlay();
                sessionStorage.setItem('popupShown', 'true');
            });

            popupDiv.innerHTML = iframeContent;
            popupDiv.appendChild(closeButton);

            var overlay = document.createElement('div');
            overlay.className = 'popup-overlay';
            overlay.addEventListener('click', function() {
                document.body.removeChild(popupDiv);
                removeOverlay();
                sessionStorage.setItem('popupShown', 'true');
            });

            document.body.appendChild(overlay);
            document.body.appendChild(popupDiv);

            // Escape key event listener
            document.addEventListener('keydown', function(event) {
                if (event.key === 'Escape') {
                    document.body.removeChild(popupDiv);
                    removeOverlay();
                    sessionStorage.setItem('popupShown', 'true');
                }
            });
        }

        function removeOverlay() {
            var overlay = document.querySelector('.popup-overlay');
            if (overlay) {
                document.body.removeChild(overlay);
            }
        }

        // Define the function in the global scope explicitly
        window.openNewsletterPopup = function() {
            console.log("openNewsletterPopup called");
            showPopup();
        };

        // Automatically open the popup after 5 seconds
        /*setTimeout(function() {
            console.log("Auto-opening popup...");
            showPopup();
        }, 5000);*/

        // Ensure the button click works
        var registerButton = document.getElementById('registerButton');
        if (registerButton) {
            registerButton.addEventListener('click', function() {
                console.log("Register button clicked");
                openNewsletterPopup();
            });
        } else {
            console.error("Register button not found");
        }
    }

    // Anpassung des Warenkorb-Buttons mit Verzögerung
    setTimeout(function() {
        var addToCartButton = document.getElementById('AddToCart');
        if (addToCartButton) {
            var buttonTextSpan = addToCartButton.querySelector('.loader-button__text');
            if (buttonTextSpan && buttonTextSpan.textContent.trim() === "In den Warenkorb - Nähen wir für dich!") {
                // Check for mobile viewport
                if (window.innerWidth <= 767) {
                    addToCartButton.style.fontSize = '12px';
                    addToCartButton.style.padding = '0';
                }

                // Optional: Event listener to handle window resize
                window.addEventListener('resize', function() {
                    if (window.innerWidth <= 767) {
                        addToCartButton.style.fontSize = '12px';
                        addToCartButton.style.padding = '0';
                    } else {
                        // Reset styles when not in mobile view
                        addToCartButton.style.fontSize = '';
                        addToCartButton.style.padding = '';
                    }
                });
            }
        }
    }, 500); // 500ms Verzögerung
};

(function () {
  function closeProductAccordionsOnMobile() {
    if (!window.matchMedia('(max-width: 1023px)').matches) return;

    // Focal Produkt-Tabs/Accordion: alles initial schließen (oder nur das erste)
    const wrappers = document.querySelectorAll('.product-tabs__tab-item-wrapper');
    if (!wrappers.length) return;

    // Variante A: nur den ersten (meist "Beschreibung") schließen
    const first = wrappers[0];

    // Button-State
    const btn = first.querySelector('button.collapsible-toggle[aria-expanded="true"]');
    if (btn) btn.setAttribute('aria-expanded', 'false');

    // Collapsible-State
    const cc = first.querySelector('collapsible-content[open]');
    if (cc) {
      if (typeof cc.close === 'function') cc.close();     // falls Focal eine Methode hat
      cc.removeAttribute('open');                          // fallback
    }
  }

  document.addEventListener('DOMContentLoaded', closeProductAccordionsOnMobile);

  // Falls Shopify Sections via Editor / AJAX neu geladen werden
  document.addEventListener('shopify:section:load', closeProductAccordionsOnMobile);
})();